import React from "react";
import _ from "lodash";

export type Props = {
  label: string;
  value: string | string[];
  isRequired?: boolean;
  hasError?: boolean;
  options: { label: string; value: string }[];
  onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  disabled?: boolean;
  isMultiple?: boolean;
  size?: number;
};

const SelectField: React.FC<Props> = ({
  label,
  value,
  isRequired,
  hasError = false,
  options,
  onChange,
  disabled = false,
  isMultiple = false,
}) => {
  return (
    <div className="field">
      {!_.isEmpty(label) && (
        <label className="label is-small">
          {label}
          {isRequired && <span className="has-text-danger">*</span>}
        </label>
      )}
      <div className="control is-expaned">
        <div
          className={`${
            (isRequired && (!value || (Array.isArray(value) && (value.length === 0 || !value.every((v) => !!v))))) ||
            hasError
              ? "is-danger "
              : ""
          }${isMultiple ? "is-multiple " : ""}select is-small is-fullwidth`}
        >
          <select multiple={isMultiple} className="is-radiusless" value={value} onChange={onChange} disabled={disabled}>
            <option value=""></option>
            {options.map((option, index) => (
              <option key={index} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default SelectField;
